import { getEmbarcacaoClasse } from "./embarcacoes.gateway";
import { isEmbarcacaoClasseEmpty } from "./embarcacoes.types";
import type { EmbarcacaoClasse, EmbarcacaoClasseState } from "./embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

export const CLASSE_SESSION_EXPIRED_MESSAGE =
  "Sua sessão expirou. Entre novamente para consultar os detalhes da embarcação.";
export const CLASSE_FORBIDDEN_MESSAGE =
  "Você não tem permissão para consultar os detalhes desta embarcação.";
export const CLASSE_NOT_FOUND_MESSAGE = "Embarcação não encontrada.";
export const CLASSE_ERROR_MESSAGE = "Não foi possível carregar a Classe da embarcação.";

const CLASSE_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoClasse> = {
  load: getEmbarcacaoClasse,
  isEmpty: isEmbarcacaoClasseEmpty,
  messages: {
    sessionExpired: CLASSE_SESSION_EXPIRED_MESSAGE,
    forbidden: CLASSE_FORBIDDEN_MESSAGE,
    notFound: CLASSE_NOT_FOUND_MESSAGE,
    error: CLASSE_ERROR_MESSAGE,
  },
};

interface UseEmbarcacaoClasseResult extends EmbarcacaoClasseState {
  reload: () => void;
}

/**
 * Consulta a Classe da embarcação pedida (AC4). Somente leitura: nenhuma
 * escrita é disparada na abertura nem no fechamento do modal.
 */
export function useEmbarcacaoClasse(id: string): UseEmbarcacaoClasseResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, CLASSE_QUERY);

  return { ...state, classe: data };
}
